import React, { Component } from 'react'
import { TextField } from '@fluentui/react';
import { connect } from 'react-redux';
import { updateStepValidationStatus } from '../../actions/ValidationActions/clientValidation';
import Warning from "../CreateSite/CommonComponents/Warning";
class RequiredTextField extends Component {

    componentDidUpdate() {
        this.props.updateStepValidationStatus(this.props.name, this.isValid());
    }

    isValid() {
        return !!this.props.value;
    }

    render() {
        let error = null;
        if (this.props.possibleWarning && !this.isValid()) {
            error = `${this.props.name} cannot be empty`;
        }
        else if (!this.props.validationResult.isValid) {
            error = Array.isArray(this.props.validationResult.message) 
                    ? this.props.validationResult.message.map((msg, index) => <span key={index}>{msg}<br /></span>)
                    : this.props.validationResult.message;
        }

        const warning = this.props.possibleWarning && (!this.isValid() || !this.props.validationResult.isValid)
            ? <Warning element="withLabel"/>
            : null;

        return (
            <div>
                {warning}
                <TextField
                    label="Required"
                    required={true}
                    autoComplete="off"
                    type="text"
                    errorMessage={error}
                    disabled={this.props.isPickerDisabled}
                    {...this.props}
                />
            </div>
        )
    }
}

const mapActionToProp = {
    updateStepValidationStatus
}

const mapStateToProps = state => ({
    possibleWarning: state.wizard.nextStepRequested
})

export default connect(mapStateToProps, mapActionToProp)(RequiredTextField);



// WEBPACK FOOTER //
// ./src/components/formFields/RequiredTextField.js